<template>
  <div>
    <div class="astronomy">
      <img class="moon" :src="astronomy.moon_image">
      <span class="sunrise">{{ astronomy.sunrise }}</span>
      <span class="sunset">{{ astronomy.sunset }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['astronomy']),
  },
};
</script>

<style scoped>
.moon {
  display: block;
  margin: 0 auto 20px;
}
.sunrise, .sunset {
  font-size: 1.4em;
}
.sunset {
  display: inline-block;
  margin-left: 30px;
}
</style>
